import EndPointConfig from "../../models/api/endPointConfig";

const controller = "academyconfiguration";

export const AcademyConfigurationEP2: EndPointConfig[] = [
    new EndPointConfig().setMethod('PATCH').setController(controller).setPattern('{id}/check').setAlias('CheckAcademyConfigurationsCoincidences'),
];